// @flow

import { Evented } from "../util/evented";

import type { Source } from "./source";
import type Map from "../ui/map";
import { applyClippingFeature } from "../util/clipping_geo";
import ClippingFeature from "../data/clipping_feature";

// mapbox-gl-修改说明：新增source增强类，对source的增强方法，都可以写在这里
// 修改人：龚跃健 2024年6月17日
/**
 * @class SourceEnhance
 * @MapGISExtension
 * @classdesc 扩展Source对象的基类，目前所有source会根据此类派生
 * @category Source
 * @return {SourceEnhance} Source对象
 */
class SourceEnhance extends Evented implements Source {
    map: Map;
    _loaded: boolean;

    /**
     * @private
     */
    constructor() {
        super();
    }
    /**
     * @private
     */
    load() {}
    /**
     * @private
     */
    onAdd(map: Map) {
        this.map = map;
        this.load();
        // 初始化裁剪区
        const options = this._options || this.options;
        if (options) {
            this.setClippingArea(options.clippingArea);
        }
    }

    onRemove(map: Map) {}

    // mapbox-gl-修改说明：source上支持设置裁剪几何
    // 修改人：赵凯 2024年7月29日
    /**
     * 设置裁剪区
     * @param {Object|null} geojsonObject(目前仅支持传入区或多区几何对象)
     * @example
     * map.getSource('矢量source').setClippingArea({
        "type": "Polygon",
        "coordinates": [
          [
            [111.36341, 29.032578],
            [113, 30],
            [114.13094, 29.032578],
            [114.13094, 31.273224],
            [111.36341, 31.273224],
            [111.36341, 29.032578]
          ]
        ]
      })
     * @return {*}
     */
    setClippingArea(data: Object | null) {
        applyClippingFeature.call(this, data);
        // 触发刷新
        this.map._update();
    }

    /**
     * 获取裁剪区
     * @param {Object} data geojson的object属性
     * @return {*}
     */
    getClippingArea(): ClippingFeature | null {
        return this._clippingFeature;
    }
}

export default SourceEnhance;
